import { extractTableRows } from "./mcpTableRows"

// Die Freigabe-Anfrage im KI-Chat (Löschen, Veröffentlichen) zeigt die Argumente des Tools. Die Einzel-Tools
// bekommen nur IDs ("folder id: 6ad623e9..."), der Nutzer sieht also nicht, was er löscht. Die Namen stehen
// aber in den Listenergebnissen (list_*), die das Modell vorher im selben Chat abgerufen hat: Zeilen mit
// einem <kind>_id-Feld und einem name/title. Daraus wird eine Zuordnung ID -> Name.
const NAME_FIELDS = ["name", "title", "project_title", "folder_name"]

const rowName = (row) => {
    for (const field of NAME_FIELDS) {
        if (typeof row[field] === "string" && row[field].trim()) return row[field].trim()
    }
    return null
}

// outputs: Roh-Ausgaben von Tool-Aufrufen. Eine ID, die in mehreren Zeilen mit verschiedenen Namen vorkommt
// (z. B. project_id in einer Unterliste), wird nicht aufgelöst: lieber die ID zeigen als einen falschen Namen.
export const buildIdNameMap = (outputs) => {
    const map = new Map()
    const ambiguous = new Set()
    for (const output of Array.isArray(outputs) ? outputs : []) {
        const { rows } = extractTableRows(output)
        for (const row of rows) {
            const name = rowName(row)
            if (!name) continue
            for (const [key, value] of Object.entries(row)) {
                if ((key === "id" || key.endsWith("_id")) && typeof value === "string" && value) {
                    if (map.has(value) && map.get(value) !== name) ambiguous.add(value)
                    map.set(value, name)
                }
            }
        }
    }
    ambiguous.forEach((id) => map.delete(id))
    return map
}

// Ersetzt die Anzeige einer ID durch "Name (id 6ad623e9)", wenn der Name bekannt ist.
export const describeId = (value, idNames) => {
    const name = idNames && typeof value === "string" ? idNames.get(value) : null
    return name ? `${name} (id ${value.slice(0, 8)})` : value
}

// Tools, die etwas in Quaro anlegen, aendern oder loeschen. Fuer sie zeigt die Quellenliste unter der Antwort
// die Argumente (mit aufgeloesten Namen), damit der Nutzer sieht, was geaendert wurde - nicht nur den Toolnamen.
// Reine Lese- und Rechen-Tools (get_*, list_*, search_*, ask_llm, audit_page, analyze_*) bleiben ohne Zeile.
export const isChangeTool = (name) => /^(create|update|add|assign|set|rename|complete|comment|delete|remove|publish|unpublish|move|setup|save|categorize|run|generate|import)_/.test(String(name || ""))

// Alle Ausgaben aus Chat-Nachrichten (message.tables[].rawOutput) und der aktuellen Antwort sammeln.
export const collectOutputs = (messages, currentTables) => {
    const outputs = []
    for (const message of Array.isArray(messages) ? messages : []) {
        for (const table of (message && message.tables) || []) if (table && table.rawOutput) outputs.push(table.rawOutput)
    }
    for (const table of Array.isArray(currentTables) ? currentTables : []) if (table && table.rawOutput) outputs.push(table.rawOutput)
    return outputs
}
